export default __webpack_public_path__ + "static/media/question.2f492019.svg";